import {
  OnBoardingController,
  DomUtil
} from "cartovista";
import {
  GuidedTourConfig
} from "cartovistaExtend/appTools/GuidedTourConfig";

export default class OnBoardingControllerExtend extends OnBoardingController {}

var OnBoardingController_generateSteps = OnBoardingController.prototype._generateSteps;
OnBoardingController.prototype._generateSteps = function() {
  OnBoardingController_generateSteps.call(this);
  this._steps = [];
  var e = DomUtil.isResponsiveUI();
  this._steps = _.compact(_.map(GuidedTourConfig.STEPS, function(stepConfigs) {
    var element = document.querySelector(stepConfigs.querySelector);
    return element ? {
      element: e ? null : element,
      intro: "<div class='title'>" + stepConfigs.title + "<div><div class='message'>" + stepConfigs.message + "<div>",
      position: stepConfigs.position ? stepConfigs.position : null
    } : null;
  }));
}

var OnBoardingController_OnBoardingOnBeforeChange = OnBoardingController.prototype._OnBoardingOnBeforeChange;
OnBoardingController.prototype._OnBoardingOnBeforeChange = function(e) {
  OnBoardingController_OnBoardingOnBeforeChange.call(this, e);
};

var OnBoardingController_exitOnBoarding = OnBoardingController.prototype._exitOnBoarding;
OnBoardingController.prototype._exitOnBoarding = function() {
  OnBoardingController_exitOnBoarding.call(this);
}
